import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ resource, filter, page, size }) =>
    present(
      repository
        .getPersonalTimeSheet(resource, filter, page, size)
        .then((timeSheet) => ({ resource, timeSheet, filter, page, size }))
        .catch(() => Promise.reject({ resource, filter, page, size })),
    );
}

export type { Interactor };

export { createInteractor };
